export const GiftCreditStatus = {

    ACTIVE:"فعال",
    INACTIVE:"غیر فعال",
    REGISTERED:"ثبت نام شده",
    EXPIRED:"منقضی",
    USED:"استفاده شده",
    DRAFT:"پیشنویس"

}
